module.exports = __webpack_public_path__ + "img/spy-guide_zh.d55b3e23.png";